import axios from 'axios';
import { SERVER_URL } from "../const";
import Qs from 'qs';


export const getRodtepDataService = async (iec_no, filters) => {
  const token = localStorage.getItem('token');
  try {
    let params = {
      iec_no,
      ...filters,
      br_code: filters.br_code
    };
    // Make a GET request to fetch Rodtep data based on the IEC number
    const response = await axios.get(`${SERVER_URL}/get-rodtep-details`, {
      params,
      paramsSerializer: params => {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      },
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data; // Return the data from the response
  } catch (error) {
    throw new Error('Error fetching Rodtep data:', error);
  }
};

export const getRodtepImportDataService = async (iec_no, filters) => {
  const token = localStorage.getItem('token');
  try {
    let params = {
      iec_no,
      ...filters,
      br_code: filters.br_code
    };
    // Make a GET request to fetch Rodtep data based on the IEC number
    const response = await axios.get(`${SERVER_URL}/get-rodtep-scrip-details`, {
      params,
      paramsSerializer: params => {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      },
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data; // Return the data from the response
  } catch (error) {
    throw new Error('Error fetching Rodtep data:', error);
  }
};


export const submitPurchase = async (formData) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(SERVER_URL + "/create_scrip", formData, {
      headers: {
        'Authorization': 'Bearer ' + token,
      },
    });

    if (response.status === 200) {
      return response;
    } else {
      throw new Error(response?.data?.detail || "Something went wrong!");
    }
  } catch (error) {
    console.error('Error:', error.message);
    throw error.response?.data?.detail ? new Error(error.response.data.detail) : error;  // Return API error message
  }
};


export const tradeScrip = async (formData) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(SERVER_URL + "/create_trading", formData, {
      headers: {
        'Authorization': 'Bearer ' + token,
      },
    });

    if (response.status === 200) {
      return response;
    } else {
      console.error('API Error:', response.statusText);
      throw new Error(response?.data?.detail || "Something went wrong!");

      // return []
    }
  } catch (error) {
    console.error('Error:', error.message);
    throw error.response?.data?.detail ? new Error(error.response.data.detail) : error;  // Return API error message

  }
};


